module.exports = __webpack_public_path__ + "img/my_booking.457b74cb.png";